import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./Redux/ConfigureStore";
import ErrorBoundary from "./ErrorHandler/functionalBoundary";
import { datadogRum } from '@datadog/browser-rum';
import { Toaster as Sonner } from "./components/career-coach/component/ui/sonner";
import { Toaster } from "./components/career-coach/component/ui/toaster";
import { TooltipProvider } from "./components/career-coach/component/ui/tooltip";
// Add these lines at the top of your entry file
const buffer = require('buffer');
global.Buffer = buffer.Buffer;

datadogRum.init({
  applicationId: 'c9b4167c-b75a-4b48-9502-2185638e5827',
  clientToken: 'puba0a08ff2fc7993d88d0c266637ef8904',
  // `site` refers to the Datadog site parameter of your organization
  // see https://docs.datadoghq.com/getting_started/site/
  site: 'datadoghq.com',
  service: 'candidate',
  env: process.env.NODE_ENV || 'production',
  // Specify a version number to identify the deployed version of your application in Datadog
  version: '1.0.0',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input',
});

datadogRum.startSessionReplayRecording(); // Optional: to record user sessions

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <HelmetProvider>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <TooltipProvider>
            <Toaster />
            <Sonner />
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </TooltipProvider>
        </PersistGate>
      </Provider>
    </HelmetProvider>
  </ErrorBoundary>
);
